export const setFormInfo = (data) => {
   return {
      type: "SET_FORM_INFO",
      payload: data,
   };
};

export const setAnswer = (data, formUuid) => {
   return {
      type: "SET_ANSWER",
      payload: {
         data,
         formUuid,
      },
   };
};

export const deleteFormInfo = (data) => {
   return { type: "DELETE_FORM_INFO", payload: data };
};

export const clearFormInfo = () => {
   return { type: "CLEAR_FORM_INFO" };
};

export const setSqlValues = (data) => {
   return { type: "SET_SQL_VALUES", payload: data };
};

export const setGridSqlValues = (data) => {
   return { type: "SET_GRID_SQL_VALUES", payload: data };
};

export const resetAllSqlValues = () => {
   return { type: "RESET_ALL_SQL_VALUES" };
};

export const setListTableResponses = (data) => {
   return { type: "SET_LIST_TABLE_RESPONSES", payload: data };
};

export const setMailTitle = (data) => {
   return { type: "SET_MAIL_TITLE", payload: data };
};

export const setGridFormRefs = (data) => {
   return { type: "SET_GRID_FORM_REFS", payload: data };
};

export const addGridFormRef = (data) => {
   return { type: "ADD_GRID_FORM_REF", payload: data };
};

export const removeGridFormRef = (data) => {
   return { type: "REMOVE_GRID_FORM_REF", payload: data };
};

export const setGridRequestFieldId = (data) => {
   return {
      type: "SET_GRID_REQUEST_FIELD_ID",
      payload: data,
   };
};
export const setComments = (data) => {
   return {
      type: "SET_COMMENTS",
      payload: data,
   };
};

export const clearComments = () => {
   return {
      type: "CLEAR_COMMENTS",
   };
};

export const setMessageHistory = (data) => {
   return {
      type: "SET_MESSAGE_HISTORY",
      payload: data,
   };
};

export const clearMessageHistory = () => {
   return {
      type: "CLEAR_MESSAGE_HISTORY",
   };
};

export const setListTablePromise = (techName, promise) => {
   return {
      type: "SET_LIST_TABLE_PROMISE",
      payload: { techName, promise },
   };
};

export const resolveListTablePromise = (techName) => {
   return {
      type: "RESOLVE_LIST_TABLE_PROMISE",
      payload: techName,
   };
};

export const clearListTablePromises = () => {
   return {
      type: "CLEAR_LIST_TABLE_PROMISES",
   };
};
